export default __webpack_public_path__ + "static/dark-mode-a763061909c07f67615e4321ff1b7a9b.png";